/*
 * @Description: 企业API设置
 * @Author: xxx
 * @Date: 2026-06-08
 */
import service from '@/utils/request'

// 列表
export const getList = (params: any) =>
  service.request({
    method: 'post',
    url: 'enterpriseCrypto/page',
    data: params
  })

// 新增
export const addApi = (params: any) =>
  service.request({
    method: 'post',
    url: 'enterpriseCrypto/add',
    data: params
  })

// 编辑
export const editApi = (params: any) =>
  service.request({
    method: 'post',
    url: 'enterpriseCrypto/edit',
    data: params
  })

// 企业下拉
export const dropdownOfEnterprise = (params: any) =>
  service.request({
    method: 'post',
    url: 'admin/enterprise/dropdownOfEnterprise',
    data: params
  })
